export default __webpack_public_path__ + "static/media/logo.2eb384f0.mp4";